module.exports = __webpack_public_path__ + "img/gift-9.7cc649cf.jpg";